import { Typography } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

const OgTagListItems = ({ formData, onEdit }) => {
  return (
    <div className="container">
      <div className="label"></div>
      <div>
        <div className="answer">
          <h4 className="quest-header"> ogTitle</h4>
          <Typography> {formData?.ogTitle}</Typography>
          {/* <DeleteIcon style={{ cursor: "pointer" }}> </DeleteIcon> */}
          <EditIcon style={{ cursor: "pointer" }} onClick={onEdit} />
        </div>
        <div className="answer">
          <h4 className="quest-header"> ogDescription</h4>
          <Typography> {formData?.description}</Typography>
          {/* <DeleteIcon style={{ cursor: "pointer" }}> </DeleteIcon> */}
        </div>
        <div className="answer">
          <h4 className="quest-header">site name</h4>
          <Typography> {formData?.site_name}</Typography>
          {/* <DeleteIcon style={{ cursor: "pointer" }}> </DeleteIcon> */}
        </div>
        <div className="answer">
          <h4 className="quest-header">ogUrl</h4>
          <Typography>{formData?.ogUrl}</Typography>
        </div>

        <div className="answer">
          <h4 className="quest-header">ogType</h4>
          <Typography>{formData?.ogType}</Typography>
        </div>
        <div className="answer">
          <h4 className="quest-header">ogLocale</h4>
          <Typography>{formData?.ogLocale}</Typography>
        </div>

        <div className="answer">
          <h4 className="quest-header"> og:image</h4>
          <Typography>{formData?.ogImage}</Typography>
        </div>

        <div className="answer">
          <h4 className="quest-header"> twitter:card</h4>
          <Typography>{formData?.twitterCard}</Typography>
        </div>

        <div className="answer">
          <h4 className="quest-header"> twitter:site</h4>
          <Typography>{formData?.twitterSite}</Typography>
        </div>

        <div className="answer">
          <h4 className="quest-header"> twitter:creator</h4>
          <Typography>{formData?.twitterCreator}</Typography>
        </div>

        <div className="answer">
          <h4 className="quest-header"> twitter:title</h4>
          <Typography>{formData?.twitterTitle}</Typography>
        </div>

        <div className="answer">
          <h4 className="quest-header"> twitter:description</h4>
          <Typography>{formData?.twitterDescription}</Typography>
        </div>
        <div className="answer">
          <h4 className="quest-header"> twitter:image</h4>
          <Typography>{formData?.twitterImage}</Typography>
        </div>

        <div
          style={{
            width: "100%",
            background: "gray",
            height: "1px",
            marginTop: "30px",
          }}
        ></div>
      </div>
    </div>
  );
};

export default OgTagListItems;
